import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    width: '100%',
    backgroundColor: '#fff',
    padding: '0rem 10px 0rem 10px',
    minHeight: 'calc(100vh - 130px)',
  },
}));
